import { ROUTES } from '@/config/routes';

export const PORTAL_ORIGIN = (process.env.REACT_APP_PORTAL_ORIGIN || '').replace(/\/$/, '');

export const PORTAL_HOME_URL = `${PORTAL_ORIGIN}/home`;

export const ED_URL = (process.env.REACT_APP_ED_URL || '').replace(/\/$/, '');

export type NavigationItem = {
  title: string;
  path: string;
};

export const MAIN_NAVIGATION_ITEMS: NavigationItem[] = [
  {
    title: 'Главная',
    path: PORTAL_HOME_URL,
  },
  {
    title: 'Launcher',
    path: ROUTES.HOME,
  },
  {
    title: 'Сотрудники',
    path: `${ED_URL}/employees`,
  },
  {
    title: 'Команда',
    path: `${ED_URL}/team`,
  },
  {
    title: 'Новости',
    path: `${PORTAL_ORIGIN}/news`,
  },
  {
    title: 'Сервисы и заявки',
    path: `${PORTAL_ORIGIN}/allservices`,
  },
  {
    title: 'Территория развития',
    path: `${PORTAL_ORIGIN}/_wt/territory/7249326467334411212`,
  },
  {
    title: 'Сообщества',
    path: `${PORTAL_ORIGIN}/social#/`,
  },
  {
    title: 'Мои достижения',
    path: `${PORTAL_ORIGIN}/_wt/achievements`,
  },
  {
    title: 'Магазин призов',
    path: `${PORTAL_ORIGIN}/_wt/shop_prize_familia`,
  },
  {
    title: 'Наши магазины',
    path: `${ED_URL}/stores`,
  },
];

export const isExternalNavigationPath = (path: string) => /^https?:\/\//.test(path);
